import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { NotifierService } from 'angular-notifier';
import { environment } from './../../environments/environment';
import { BehaviorSubject } from 'rxjs';

declare var google;

@Injectable()
export class CommonService {

  rootData: any = {};
  readonly notifier: NotifierService;
  private loginUserDataSource = new BehaviorSubject<any>(this.getLoginUserData());
  loginUserData$ = this.loginUserDataSource.asObservable();
  public currencySymbol: string;
  public defaultCurrency: string;
  public currentCurrency: string;
  public currencyConversionRate: any;
  public taxRatio: number;
  public stripePublishKey: string;
  Math = Math;

  constructor(private http: HttpClient, notifierService: NotifierService) {
    this.rootData.rootUrl = environment.WebAPIUrl;
    this.rootData.rootFilePath = environment.FileBasePath;
    // this.rootData.uploadsUrl = environment.uploadsUrl;
    //this.rootData.frontendUrl = environment.frontendUrl;
    this.notifier = notifierService;
    this.currencySymbol = '$'; 
    this.taxRatio = 0; 
    this.stripePublishKey = 'pk_live_51QkdtFGgbIgV1zHLAFfRJvBUmBHqYSA8IquU2A7mkVdc43oRSzpnw2OqakXG0zpVGFrFeU105yKEXt9LKWkmsxW700iV6DxeQ5'; 
    // this.stripePublishKey = 'pk_test_51QkdtFGgbIgV1zHLAg2VBBkckPki0qHxt1rb5RqjY2MM51Vti4SnJo8vhsiZIxDewlL2NVgUveBT8Xsv9dDT2uKC00olYH98Lw'; 
  }

  getLoginUserData(): any {
    return JSON.parse(localStorage.getItem('LoginUserData') || '{}');
  }

  // Update LoginUserData and notify changes
  updateLoginUserData(updatedData: any): void {
    localStorage.setItem('LoginUserData', JSON.stringify(updatedData));
    this.loginUserDataSource.next(updatedData);
  }
}
